import { Icon } from '@chakra-ui/react';

export default function SFAddCircleFilledIcon(props) {
  return (
    <Icon
      width='24px'
      height='25px'
      viewBox='0 0 24 25'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M12 24.4922C5.47266 24.4922 0.046875 19.0664 0.046875 12.5391C0.046875 6 5.46094 0.585938 11.9883 0.585938C18.5273 0.585938 23.9531 6 23.9531 12.5391C23.9531 19.0664 18.5391 24.4922 12 24.4922ZM6.28125 12.5508C6.28125 13.1484 6.70312 13.5469 7.3125 13.5469H10.9805V17.2266C10.9805 17.8242 11.3906 18.2578 11.9883 18.2578C12.5977 18.2578 13.0195 17.8359 13.0195 17.2266V13.5469H16.6992C17.2969 13.5469 17.7305 13.1484 17.7305 12.5508C17.7305 11.9414 17.2969 11.5195 16.6992 11.5195H13.0195V7.85156C13.0195 7.24219 12.5977 6.80859 11.9883 6.80859C11.3906 6.80859 10.9805 7.24219 10.9805 7.85156V11.5195H7.3125C6.70312 11.5195 6.28125 11.9414 6.28125 12.5508Z' />
    </Icon>
  );
}
